import React from "react";
import {
  HeartHandshake, FlaskConical, Compass, Lightbulb,
  Mountain, Sparkles, GraduationCap, Brain, ScanLine,
} from "lucide-react";
import { useSiteContent } from "@/lib/siteContent";

const ICONS = [
  <HeartHandshake className="w-6 h-6" key="i0" />,
  <FlaskConical className="w-6 h-6" key="i1" />,
  <Compass className="w-6 h-6" key="i2" />,
  <Lightbulb className="w-6 h-6" key="i3" />,
  <Mountain className="w-6 h-6" key="i4" />,
  <Sparkles className="w-6 h-6" key="i5" />,
  <GraduationCap className="w-6 h-6" key="i6" />,
  <Brain className="w-6 h-6" key="i7" />,
  <ScanLine className="w-6 h-6" key="i8" />,
];

export const Differentiators = () => {
  const { content } = useSiteContent();
  const ITEMS = content.diff_items || [];
  return (
    <section className="py-24 lg:py-32 bg-[#F4EFE6] relative">
      <div className="absolute inset-0 grain opacity-50" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <div>
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#CBA358] font-semibold">
              {content.diff_eyebrow}
            </div>
            <h2 className="font-display text-4xl lg:text-5xl mt-4 text-[#0A2342] leading-[1.05] text-balance max-w-2xl">
              {content.diff_headline}
            </h2>
          </div>
          {content.diff_description && (
            <p className="max-w-sm text-[#5C636A] leading-relaxed">
              {content.diff_description}
            </p>
          )}
        </div>

        <div
          className={`grid sm:grid-cols-2 gap-4 ${
            ITEMS.length === 5 ? "lg:grid-cols-5" : "lg:grid-cols-3"
          }`}
        >
          {ITEMS.map((it, idx) => (
            <div
              key={idx}
              className="group bg-white border border-[#E5DFD3] p-6 hover:border-[#CBA358] hover:-translate-y-1 transition-all"
            >
              <div className="w-11 h-11 flex items-center justify-center bg-[#0A2342] text-[#CBA358] mb-4 group-hover:bg-[#CBA358] group-hover:text-[#0A2342] transition-colors">
                {ICONS[idx % ICONS.length]}
              </div>
              <h3 className="font-display text-lg text-[#0A2342]">{it.title}</h3>
              <p className="mt-2 text-sm text-[#5C636A] leading-relaxed">{it.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Differentiators;
